import React, { createContext, useContext, ReactNode } from 'react';

interface SampleTrackingConfigContextValue {
  researchProjectId: string;
  configuredTransitionId?: string;
  transitionEnumId?: string;
}

const SampleTrackingConfigContext = createContext<SampleTrackingConfigContextValue | undefined>(undefined);

interface SampleTrackingConfigProviderProps {
  children: ReactNode;
  researchProjectId: string;
  configuredTransitionId?: string;
  transitionEnumId?: string;
}

export const SampleTrackingConfigProvider: React.FC<SampleTrackingConfigProviderProps> = ({
  children,
  researchProjectId,
  configuredTransitionId,
  transitionEnumId,
}) => {
  const value: SampleTrackingConfigContextValue = {
    researchProjectId,
    configuredTransitionId,
    transitionEnumId,
  };

  return <SampleTrackingConfigContext.Provider value={value}>{children}</SampleTrackingConfigContext.Provider>;
};

export const useSampleTrackingConfig = (): SampleTrackingConfigContextValue => {
  const context = useContext(SampleTrackingConfigContext);
  if (context === undefined) {
    throw new Error('useSampleTrackingConfig must be used within a SampleTrackingConfigProvider');
  }
  return context;
};
